// @core/api/endpoints/secret/get_seal_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SealStatusResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get seal status
 * Returns the current seal/unseal state, initialization status, and cluster information. Safe to call when sealed.
 * @public This endpoint does not require authentication
 */
export async function GetSealStatus(
  params?: {
  },
  options?: RequestOptions
): Promise<SealStatusResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/sys/seal-status`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<SealStatusResponse>(requestPath, { ...requestOptions, params });
}
